import { render, staticRenderFns } from "./RoomForm.vue?vue&type=template&id=71f26ece"
import script from "./RoomForm.vue?vue&type=script&lang=js"
export * from "./RoomForm.vue?vue&type=script&lang=js"
import style0 from "./RoomForm.vue?vue&type=style&index=0&id=71f26ece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports